<div class="login">
  <div class="panel">
    <div class="brand"><span class="gear">S</span> SPAREX</div>
    <h1>Admin login</h1>
    <p class="hint">UAT: superadmin&#64;sparex.local / Admin&#64;123</p>

    @if (error()) {
      <p-message severity="error" [text]="error()!" styleClass="w-full mb" />
    }

    <div class="field">
      <label for="admin-email">Email</label>
      <input id="admin-email" pInputText type="email" [(ngModel)]="email" class="w-full" autocomplete="username" />
    </div>

    <div class="field">
      <label for="admin-password">Password</label>
      <p-password
        inputId="admin-password"
        [(ngModel)]="password"
        [feedback]="false"
        [toggleMask]="true"
        [style]="{ width: '100%' }"
        [inputStyle]="{ width: '100%' }"
        styleClass="w-full"
        inputStyleClass="w-full"
        autocomplete="current-password"
      />
    </div>

    <div class="actions">
      <p-button label="Sign in" (onClick)="submit()" [loading]="loading()" styleClass="w-full" />
    </div>
  </div>
</div>
